import { documents } from 'api';
import { UPLOAD_DOCUMENT, DELETE_DOCUMENT } from 'store/actions/documents';

export default {
  [UPLOAD_DOCUMENT]: (params, { folder, docType, file }) =>
    new Promise((resolve, reject) => {
      documents
        .uploadDocument({ folder, docType, file })
        .then(
          ({ data }) => {
            resolve(data);
          },
          err => {
            reject(err);
          }
        )
        .catch();
    }),

  [DELETE_DOCUMENT]: (params, { folder, fileName }) =>
    new Promise((resolve, reject) => {
      documents
        .deleteDocument({ folder, fileName })
        .then(
          ({ data }) => {
            resolve(data);
          },
          err => {
            reject(err);
          }
        )
        .catch();
    })
};
